import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.StatementBalance.DeleteFile.IRequest;
type Response = Api.Core.StatementBalance.DeleteFile.IResponse;
type Headers = Api.Core.StatementBalance.DeleteFile.IHeaders;
const apiStatementBalanceDeleteFilePath = '/api/DealerManagement/StatementBalance/:id/DeleteFile/:fileId';
export default async function statementBalanceDeleteFileApi(id: number, request: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    body: request,
    url: createPathFromRoute(apiStatementBalanceDeleteFilePath, { id, fileId: request.fileId }),
    method: HttpMethod.delete,
    headers: getDefaultHeaders(),
  });
}
